import { useState } from 'react';
import { RockingPanel } from './RockingPanel.jsx';
import { StatNumber } from './StatNumber.jsx';

export function CaseCard({ data, onBreakdown }) {
  const [expanded, setExpanded] = useState(false);

  function toggle() {
    setExpanded((prev) => !prev);
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      toggle();
    }
  }

  return (
    <RockingPanel className={`case-card reveal${expanded ? ' expanded' : ''}`}>
      <div
        className="case-card-trigger"
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
        aria-controls={`${data.id}-detail`}
        aria-label={`${data.title} — read the case`}
        onClick={toggle}
        onKeyDown={handleKeyDown}
      >
        <div className="case-card-head">
          <span className="case-id">{data.caseId}</span>
          <span className="case-tag">{data.tag}</span>
        </div>
        <h3>{data.title}</h3>
        <p className="case-meta">{data.meta}</p>
        <div className="case-stat">
          <StatNumber target={data.stat.target} suffix={data.stat.suffix} />
          <span className="stat-label">{data.stat.label}</span>
        </div>
        <span className="expand-label">
          <span className="label-collapsed">Read the case</span>
          <span className="label-expanded">Close</span>
          <span className="plus">+</span>
        </span>
      </div>
      <div className="case-detail" id={`${data.id}-detail`}>
        <div className="case-detail-inner">
          <div className="case-detail-content">
            {data.detail.map((block) => (
              <div key={block.h}>
                <h4>{block.h}</h4>
                {block.p && <p>{block.p}</p>}
                {block.list && (
                  <ul className="decision-list">
                    {block.list.map((item) => (
                      <li key={item.strong}>
                        <strong>{item.strong}</strong>
                        {item.text}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
            <p className="case-note">{data.note}</p>
            {data.breakdownLink && (
              <a
                href="#/work/solar/breakdown"
                className="breakdown-link"
                onClick={(event) => {
                  event.preventDefault();
                  onBreakdown?.();
                }}
              >
                Read the full breakdown →
              </a>
            )}
          </div>
        </div>
      </div>
    </RockingPanel>
  );
}
